import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { LifeBuoy } from "lucide-react";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

const CATS = ["Account", "Wallet / Withdrawal", "Referral", "KYC", "Technical", "Other"];

export default function Support() {
  const [f, setF] = useState({ category: "Account", subject: "", description: "", priority: "normal" });
  const [tickets, setTickets] = useState([]);
  const load = () => api.get("/support/tickets").then((r) => setTickets(r.data)).catch(() => {});
  useEffect(load, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/support/tickets", f);
      toast.success("Ticket created");
      setF({ category: "Account", subject: "", description: "", priority: "normal" });
      load();
    } catch (err) { toast.error(apiError(err.response?.data?.detail)); }
  };

  return (
    <div className="space-y-6 max-w-2xl">
      <h1 className="font-display text-2xl sm:text-3xl font-extrabold text-[#0B223D]">Support</h1>
      <form onSubmit={submit} className="bg-white border border-slate-200 rounded-2xl p-6 space-y-4" data-testid="support-form">
        <div>
          <Label className="font-semibold text-slate-600">Category</Label>
          <select value={f.category} onChange={(e) => setF({ ...f, category: e.target.value })} data-testid="support-category" className="mt-1.5 w-full h-11 rounded-xl border border-slate-200 px-3 bg-white">
            {CATS.map((c) => <option key={c}>{c}</option>)}
          </select>
        </div>
        <div><Label className="font-semibold text-slate-600">Subject</Label><Input required value={f.subject} onChange={(e) => setF({ ...f, subject: e.target.value })} data-testid="support-subject" className="mt-1.5 h-11" /></div>
        <div><Label className="font-semibold text-slate-600">Description</Label><Textarea required value={f.description} onChange={(e) => setF({ ...f, description: e.target.value })} data-testid="support-description" className="mt-1.5" rows={4} /></div>
        <Button type="submit" className="bg-[#0B223D] text-white font-bold h-11 rounded-xl px-6" data-testid="support-submit-btn">Create ticket</Button>
      </form>

      <div>
        <h3 className="font-display font-bold text-lg text-[#0B223D] mb-3">My tickets</h3>
        {tickets.length === 0 ? <p className="text-slate-400 text-sm">No tickets yet.</p> : (
          <div className="space-y-2">
            {tickets.map((t) => (
              <div key={t.id} className="bg-white border border-slate-200 rounded-xl p-4 flex justify-between">
                <div><p className="font-semibold text-[#0B223D]">{t.subject}</p><p className="text-xs text-slate-400">{t.category} · {t.id}</p></div>
                <span className="px-2.5 py-1 rounded-full text-xs font-semibold bg-slate-100 text-slate-600 capitalize self-start">{t.status}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
